import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { RoleSelectionRoutingModule } from './role-selection-routing.module';
import { RoleSelectionComponent } from './role-selection.component';

import { QuartzModule } from '@quartzds/core-angular'
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    RoleSelectionRoutingModule,
    QuartzModule
  ],
  declarations: [RoleSelectionComponent]
})
export class RoleSelectionModule {}
